import { render } from "./NameView.vue?vue&type=template&id=81d82224&scoped=true"
import script from "./NameView.vue?vue&type=script&lang=js"
export * from "./NameView.vue?vue&type=script&lang=js"

import "./NameView.vue?vue&type=style&index=0&id=81d82224&lang=css&scoped=true"

import exportComponent from "/Users/peterdevos/Sites/aethonspel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81d82224"]])

export default __exports__